import React from 'react';

import LeftMenuContainer from '../../left-menu/left-menu-container';
import { Helpers } from "../../core/src/helpers";
import SearchResults from '../../search-filter/components/search-results';
import SearchTopBar from '../../search-filter/components/search-top-bar';
import SearchHits from '../../search-filter/components/search-hits';
import SearchLoadMore from '../../search-filter/components/search-load-more';
import VWAProductList from './vwa-product-list';
import VWAMobileFilter from './vwa-mobile-filter';
import VWASort from './vwa-sort';
import VWAFilterCount from './vwa-filter-count';
import VWAQuickFilters from './vwa-quick-filters';
import FilterMenu from '../../filters';
import ProductResults from '../../product/components/product-results';
import CompareDrawer from '../../compare/components/compare-drawer';
import Button from '../../ui/components/button';

import '../css/vwa-v2.less';

const { memoize } = Helpers;

const SORT_OPTIONS = [
    { label: 'Best seller', field: 'rank.default', order: 'asc', value: 0 },
    { label: 'Lowest price', field: 'salePrice', order: 'asc', value: 1 },
    { label: 'Highest price', field: 'salePrice', order: 'desc', value: 2 },
    { label: 'Name', field: 'name>keyword', order: 'asc', value: 3 },
    { label: 'Rating', field: 'rating', order: 'desc', value: 4 },
    { label: 'Newest', field: 'rank.newest', order: 'asc', value: 5 }
];

/**
 * On initial page load Swiftype results are fetched all at once during the SSR stage.
 * That's done to capture the top most relevant results for the keyword and to
 * be able to sort those results through JavaScript later without hitting the
 * Swiftype API (it mixes irrelevant results into the list when sorting).
 *
 * Due to this fact pagination on DLP is entirely controlled by this component's state.
 * Also keep in mind that pagination works with SSR enabled only.
 */
class VWA extends React.PureComponent {
    static defaultProps = {
        heroBanner: {},
        categoryFilters: {}
    }

    constructor(props) {
        super(props);
    }

    getTabs = memoize((defaultExpandedFilters) => {
        let tabs = [{
            Component: FilterMenu,
            title: 'Filter',
            active: true,
            tabProps: {
                useAlias: true,
                defaultExpandedFilters,
                className: 'v2',
                isV2: true
            }
        }];

        return tabs;
    });

    render() {
        const { categoryFilters, heroBanner } = this.props;
        const { facets, filterTitle, defaultExpandedFilters = 6 } = categoryFilters;
        
        return (
            <div className="clearfix vwa v2">
                <div className={'title-section'}>
                    <h1>{filterTitle}</h1>
                    <VWAQuickFilters />
                </div>
                <VWAMobileFilter sortOptions={SORT_OPTIONS} defaultExpandedFilters={defaultExpandedFilters} watchFields={/facets.*|price|rating/}/>
                <SearchTopBar className='v2'>
                    <VWAFilterCount />
                    <SearchHits className='v2' />
                    <VWASort sortOptions={SORT_OPTIONS}/>
                </SearchTopBar>
                <LeftMenuContainer
                    defaultVisibility={true}
                    tabs={this.getTabs(defaultExpandedFilters * 1)}
                    sticky={false}
                    lockMenu={true}
                    minTabs={2}
                    className={"v2"}
                    hideMobile={true}
                />
                <ProductResults>
                    <SearchResults>
                        {({ results }) => (
                            <React.Fragment>
                                <VWAProductList results={results} />
                                <SearchLoadMore>
                                    {
                                        ({ onClick, isLastPage }) => {
                                            return (!isLastPage ? <Button 
                                                        className={'search-load-more'}
                                                        type={'secondary'} 
                                                        color={'primary'} 
                                                        text={"LOAD MORE"} 
                                                        action={'add'} onClick={onClick}/> : null);
                                        }
                                    }
                                </SearchLoadMore> 
                            </React.Fragment>
                        )}
                    </SearchResults>
                </ProductResults>
                <CompareDrawer />
            </div>
        );
    }
}

export default VWA;
